module.exports = __webpack_public_path__ + "static/media/chevron-down.4cdfde93.svg";